var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgW2 = function SvgW2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1080,
    height: 1350,
    viewBox: "0 0 810 1012.5"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "w2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.145 278.133h385.71v385.715h-385.71Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w2_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M405 278.133c-106.512 0-192.855 86.347-192.855 192.86 0 106.507 86.343 192.855 192.855 192.855S597.855 577.5 597.855 470.992c0-106.512-86.343-192.86-192.855-192.86m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w2_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.145.133h385.71v385.715H.145Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w2_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193 .133C86.488.133.145 86.48.145 192.993.145 299.5 86.488 385.847 193 385.847S385.855 299.5 385.855 192.992C385.855 86.48 299.512.132 193 .132m0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w2_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h386v386H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w2_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.285 326h165.668v289.984H322.285Zm0 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w2_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w2_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w2_svg__c)",
    transform: "translate(212 278)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w2_svg__d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w2_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ed5c2f",
    d: "M.145.133h385.71v385.715H.145Zm0 0"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#w2_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff8e9",
    fillRule: "evenodd",
    d: "M360.41 501.465c17.445-23.672 37.172-52.168 44.492-63.664 13.938-21.895 27.114-45.457 37.2-69.953-9.207-4.551-20.93-7.418-34.754-7.418-16.11 0-28.743 2.906-38.282 8.261 9.473 22.532 21.727 45.485 34.747 67.309l-23.86 35c-15.648-29.73-28.605-57.637-34.23-76.543-2.168-7.285-.461-16.004 2.797-24.215 8.199-20.683 20.804-31.703 22.062-32.96 7.477-7.477 22.133-11.403 36.441-11.071 14.278.328 28.516 4.496 35.973 11.957 14.676 14.672 21.106 31.144 23.848 42.793 1.367 5.809 1.836 9.059.777 13.504-11.785 49.547-70.746 137.02-84.238 156.555-19.156 27.734-34.781 49.695-39.012 63.562-.465 1.523-2.094 1.05-2.094 1.05-.648-.327-1.605-1.487-2.664-3.355-4.37-7.71-11.906-28.136-15.363-41.437-1.05-4.047-1.727-7.442-1.836-9.64-.055-1.09.04-1.923.242-2.458 4.992-12.996 19.676-32.758 37.754-57.277m46.567 18.27 24.597-40.114c19.137 28.457 36.91 52.223 47.07 66.504 3.907 5.496 6.696 9.602 8.02 12.043.668 1.234.965 2.125.965 2.613 0 18.14-8.992 43.285-13.754 51.446-.953 1.632-1.812 2.62-2.387 2.918-.488.253-.933.44-1.57-.196-10.86-10.86-37.098-50.715-62.941-95.215m0 0"
  }))));
};
export default SvgW2;